import classNames from 'classnames';
import * as React from 'react';
import { UserContext } from '../../../contexts/UserContext';
import css from './BaseLayout.module.scss';
import GlobalFooter, {
  Props as FooterProps,
} from './GlobalFooter/GlobalFooter';

export interface Props extends React.HTMLProps<{}> {
  footerProps?: FooterProps;
}

const BaseLayout = (props: Props) => {
  const userCtx = React.useContext(UserContext);
  return (
    <div className={classNames(css.BaseLayout, props.className)}>
      {props.children}
      {!userCtx.request.isCoubicApp && (
        <div className={css.BaseLayout__Footer}>
          <GlobalFooter {...props.footerProps} withServiceFooter={false} />
        </div>
      )}
    </div>
  );
};

export default BaseLayout;
